// extracted by mini-css-extract-plugin
export default {"labelTag":"index__labelTag--IUKXa","labelTagContainer":"index__labelTagContainer--vPUnH"};